import { HomeworkAssessment } from 'views/homeworks/homework-assessment';

export default () => <HomeworkAssessment />;